// src/App.js
import React, { useState, useEffect } from 'react';
import './App.css';
import BrowseBooks from './BrowseBooks';
import MyBooks from './MyBooks';
import MyReviews from './MyReviews';
import CardVerification from './CardVerification';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db, auth } from './firebase';

import { claimBookServer, approveReviewServer, reverseExpiredClaimsServer, submitReviewServer } from './serverApi';

import { NotificationTriggers, createNotification } from './Notificationsystem.js';
import { collection, query, where, orderBy, limit, getDocs } from 'firebase/firestore';
import SettingsPage from './SettingsPage';

import {
  initializeAllPixels,
  trackPageView,
  trackSignUp,
  trackLogin,
  trackBookClaimed,
  trackReviewSubmitted,
  trackBookUploaded,
  trackViewContent,
  trackAffiliateClick
} from './PixelTracking';

import {
  createAffiliateAccount,
  trackReferralClick,
  getStoredReferralCode,
  trackReferralSignup
} from './AffiliateSystem';
import AffiliateDashboard from './AffiliateDashboard';



import {
  Book, Star, Upload, User, LogOut, Home, Library, Award, CheckCircle, 
  XCircle, Clock, ExternalLink, Coins, Crown, Image as ImageIcon, MessageSquare,
  Filter, BookOpen, Bell, Settings
} from 'lucide-react';

import { canSubmitReview, canDoActivity, initializeNewUser, isUserGated } from './SubscriptionSystem';
import { COIN_RATES } from './CoinSystem';
import { SubscriptionModal } from './PaymentSystem';
import { CustomerSupport, AdminSupport } from './CustomerSupport';
import { AMAZON_MARKETPLACES } from './AmazonMarketplaces';
import { 
  CountrySelector, 
  CountryBadges, 
  BookCountrySelector,
  filterBooksByCountry,
  adaptAmazonLink,
  getMarketplaceInfo
} from './CountrySystem';
import AdminPanel from './AdminPanel';

import UploadBookForm from './UploadBookForm_NoStorage.jsx';
import ClaimedBooksWorkflow from './ClaimedBooksWorkflow';

import BuyCoinsModal from './BuyCoinsModal';
import { LOW_COIN_THRESHOLD } from './CoinSystem';
import TermsOfService from './TermsOfService';
import PrivacyPolicy from './PrivacyPolicy';
import WelcomePage from './WelcomePage';
import { resetPassword } from './firebaseService';

import { 
  signUpUser, 
  signInUser, 
  signOutUser,
  getCurrentUser,
  updateUser,
  ensureAuthPersistence,
  listenToUser,
  getUserBookProgress,
  listenToUserBookProgress,
  listenToUserClaimedBooks,
  uploadBook,
  getAllBooks,
  submitReview,
  getAllReviews,
  updateBook,
  updateReviewStatus,
  claimBook,
  getUserClaimedBooks,
  removeClaimedBook,
  createBookProgress,
  updateBookProgress,
  getBookProgressByBookId,
  createActivity,
  listenToBooks,
  listenToReviews,
  LoadingSpinner,
  checkEmailVerified,
  resendVerificationEmail,
  onAuthChange,
  isCardVerified,
} from './firebaseService';





// ============================================
// ADDITIONS TO App.js
// ============================================



















// Full Page Loading
const FullPageLoading = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-indigo-600 mx-auto mb-4"></div>
      <p className="text-gray-600 text-lg">Loading...</p>
    </div>
  </div>
);


// Claim Loading Overlay - blocks all interaction while claiming
const ClaimLoadingOverlay = ({ show }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm mx-4 text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-indigo-600 mx-auto mb-4"></div>
        <h3 className="text-lg font-bold text-gray-800 mb-2">Claiming Book...</h3>
        <p className="text-sm text-gray-600">Please wait while we process your claim. Don't close this page.</p>
      </div>
    </div>
  );
};
const ReviewsApp = () => {
  // ===== state =====
  const [showAffiliateModal, setShowAffiliateModal] = useState(false);
  const [marketplaceFilter, setMarketplaceFilter] = useState('ALL');
  const [showForgotPassword, setShowForgotPassword] = useState(false);
const [resetEmail, setResetEmail] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [view, setView] = useState('login'); // 'login' | 'home' | 'support' | 'myBooks' | 'upload' | 'claimed' | 'writeReview' | 'myReviews' | 'analytics' | 'admin'
  const [users, setUsers] = useState([]);
  const [showWelcome, setShowWelcome] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [pendingUser, setPendingUser] = useState(null);
  // ✅ Email verification gate
  const [showVerifyEmail, setShowVerifyEmail] = useState(false);
  const [verifyEmailAddress, setVerifyEmailAddress] = useState('');
  const [unverifiedFirebaseUser, setUnverifiedFirebaseUser] = useState(null);
  const [resendLoading, setResendLoading] = useState(false);
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [reviews, setReviews] = useState([]);
  const [claimedBooks, setClaimedBooks] = useState([]);
  const [activities, setActivities] = useState([]);
  const [bookProgress, setBookProgress] = useState([]);
  const [bonusReaders, setBonusReaders] = useState([]);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationsOpen, setNotificationsOpen] = useState(false); 
  const [needsCardVerification, setNeedsCardVerification] = useState(false);
const [showBuyCoins, setShowBuyCoins] = useState(false);

  
  const [authForm, setAuthForm] = useState({ 
    email: '', 
    password: '', 
    name: '', 
    isSignup: false, 
    agreedToTerms: false
  });
  
  const [bookForm, setBookForm] = useState({
    title: '', 
    author: '', 
    genre: '', 
    description: '', 
    pageCount: '', 
    amazonLink: '',
    isPromoted: false, 
    coverImage: '', 
    keywords: '', 
    mainCharacters: '', 
    favoriteSection: '', 
    chapterHeadings: '', 
    coinsOffered: '',
    targetCountries: []
  });
  
  const [reviewForm, setReviewForm] = useState({
    bookId: null, 
    rating: 5, 
    reviewText: '', 
    amazonReviewLink: '', 
    proofScreenshot: '', 
    amazonReviewerName: ''
  });

  


  // 🔔 ADDED: Notification Helper Functions
  // ============================================
  // 1. ADD THIS FUNCTION (with your other functions)
const loadUserNotifications = async (userId) => {
  try {
    const activitiesRef = collection(db, 'activities');
    const q = query(
      activitiesRef, 
      where('userId', '==', userId),
      where('type', '==', 'notification'),
      limit(50)
    );
    
    const snapshot = await getDocs(q);
    const loadedNotifications = [];
    
    snapshot.forEach(doc => {
      const data = doc.data();
      if (data.data) {
        loadedNotifications.push({
          id: doc.id,
          ...data.data
        });
      }
    });
    
    console.log(' Loaded notifications:', loadedNotifications);
    return loadedNotifications;
  } catch (error) {
    console.error('❌ Error loading notifications:', error);
    return [];
  }
};
 // FIXED VERSION:
const createNotificationLocal = async (userId, type, title, message, metadata = {}) => {
  const notification = {
    id: Date.now().toString() + Math.random().toString(36).substr(2, 9),
    userId,
    type,
    title,
    message,
    read: false,
    createdAt: new Date().toISOString(),
    metadata
  };

  try {
    await createActivity({
      type: 'notification',
      userId,
      data: notification,
      timestamp: new Date().toISOString()
    });
    
    console.log('✅ Notification created:', notification.title);
  } catch (error) {
    console.error('❌ Error creating notification:', error);
  }

  // ALWAYS update local state if it's current user
  if (userId === currentUser?.id) {
    setNotifications(prev => [notification, ...prev]);
    console.log('🔔 Added to local notifications');
  }

  return notification;
};
  // Mark notification as read
  const markNotificationAsRead = (notificationId) => {
    setNotifications(prev =>
      prev.map(n =>
        n.id === notificationId ? { ...n, read: true } : n
      )
    );
  };

  // Clear all notifications
  const clearAllNotifications = () => {
    setNotifications([]);
  };


    // ===== CARD VERIFICATION CHECK FUNCTION (MOVED OUTSIDE useEffect) =====
  const checkCardVerification = async () => {
    if (!currentUser?.id || currentUser?.isAdmin) return;
    
    const verified = currentUser?.cardVerified === true;
    
    if (!verified) {
      console.log('🔒 Card verification required for user:', currentUser.email);
      setNeedsCardVerification(true);
    } else {
      console.log(' Card already verified for user:', currentUser.email);
      setNeedsCardVerification(false);
    }
  };

  // ===== demo data =====
  

// 1. LOAD DATA FROM LOCALSTORAGE ON APP START
// Replace your existing useEffect with demo data with this:

useEffect(() => {
  // Try to load saved data from localStorage
  
  const savedUsers = localStorage.getItem('reviewsAppUsers');
  const savedBooks = localStorage.getItem('reviewsAppBooks');
  const savedReviews = localStorage.getItem('reviewsAppReviews');
  const savedClaimedBooks = localStorage.getItem('reviewsAppClaimedBooks');
  const savedActivities = localStorage.getItem('reviewsAppActivities');
  const savedBookProgress = localStorage.getItem('reviewsAppBookProgress');
  const savedBonusReaders = localStorage.getItem('reviewsAppBonusReaders');
  
  const WELCOME_BONUS = 50;

  
  if (savedUsers) {
    setUsers(JSON.parse(savedUsers));
  } else {
    // demo users removed (dead code) - was never assigned to state
    
    


   // setBookProgress(demoProgress);
    
  }

  if (savedBonusReaders) {
    setBonusReaders(JSON.parse(savedBonusReaders));
  }

  
}, []);






// 2. SAVE DATA TO LOCALSTORAGE WHENEVER IT CHANGES
// Add these useEffect hooks after your existing useEffect

// ✅ COMPLETE FIX - Replace your existing useEffect (around line 180-230) in ReviewsApp.jsx

// Your firebaseService.js already has getAllBooks() and getAllReviews() exported ✓
// Just replace the useEffect with this updated version:

useEffect(() => {
  let unsubscribeAuth;
  let unsubscribeBooks;
  let unsubscribeReviews;
  let unsubscribeUser;
  let unsubscribeProgress;
  let unsubscribeClaimed;

  const initializeApp = async () => {
    initializeAllPixels();
    setInitialLoading(true);
    await ensureAuthPersistence();

    // ✅ STEP 3: Listen to auth state changes
    // (books/reviews are no longer read here — Firestore rules require sign-in,
    // and login is required to use the app anyway. They're loaded via the
    // real-time listeners below, attached only once a user is confirmed.)
    unsubscribeAuth = onAuthChange(async (user) => {
      console.log('🔵 Auth state changed:', user ? `User logged in: ${user.email}` : 'User logged out');
      
      if (user) {
        // ✅ Email verification gate - applies even to a rehydrated/persisted
        // session, so a signed-in-but-unverified user can't get full access
        // just by refreshing. reload() picks up a verification that
        // happened in another tab since this session was last checked.
        try {
          await user.reload();
        } catch (reloadError) {
          console.warn('⚠️ Could not reload auth user:', reloadError.message);
        }

        if (!user.emailVerified) {
          // ✅ Gate ACCESS, not the session: stay signed in (so this user's
          // own-doc Firestore reads/writes - e.g. the "resend" flow - keep
          // working under rules that key off request.auth), just don't
          // treat them as a logged-in app user. No getCurrentUser, no
          // listeners, no setView - view stays 'login' and currentUser
          // stays null, so the verify-email screen is the only thing that
          // can render for them (see the showVerifyEmail check below).
          console.log('🔵 Auth user not verified yet - routing to verify-email screen (still signed in)');
          setUnverifiedFirebaseUser(user);
          setVerifyEmailAddress(user.email);
          setShowVerifyEmail(true);
          setCurrentUser(null);
          setInitialLoading(false);
          return;
        }

        console.log('🔵 Fetching user data for:', user.uid);
        // User is signed in
        const result = await getCurrentUser(user.uid);
        console.log('🔵 User data result:', result);
        
        if (result.success) {
  console.log(' Setting current user:', result.user.name);
  setCurrentUser(result.user);
  
  // ✅ FIX: Refresh books when new user logs in
  // Books were loaded before auth, but BrowseBooks filters by currentUser.id
  // so we need to trigger a re-render with fresh books
  const freshBooks = await getAllBooks();
  if (freshBooks.success) {
    setBooks(freshBooks.books);
  }
  
  setView(result.user.isAdmin ? 'admin' : 'home');

          // ✅ STEP 4: Listen to books in real-time (only once a user is confirmed)
          unsubscribeBooks = listenToBooks((updatedBooks) => {
            console.log('🔵 Books updated in real-time:', updatedBooks.length);
            setBooks(updatedBooks);
          });

          // ✅ STEP 5: Listen to reviews in real-time (only once a user is confirmed)
          unsubscribeReviews = listenToReviews((updatedReviews) => {
            console.log('🔵 Reviews updated in real-time:', updatedReviews.length);
            setReviews(updatedReviews);
          });


          
          // ✅ Listen to user document changes (for coin updates)
          unsubscribeUser = listenToUser(user.uid, (updatedUser) => {
            setCurrentUser(updatedUser);
          });
          
          // ✅ Listen to claimed books in real-time
          unsubscribeClaimed = listenToUserClaimedBooks(user.uid, (claims) => {
            setClaimedBooks(claims);
          });
          
          // ✅ Listen to book progress in real-time
          unsubscribeProgress = listenToUserBookProgress(user.uid, (progress) => {
            setBookProgress(progress);
          });

          // 🔔 LOAD NOTIFICATIONS
const userNotifications = await loadUserNotifications(user.uid);
setNotifications(userNotifications);
console.log(' Loaded notifications:', userNotifications.length);

// ✅ LOAD ACTIVITIES
try {
  const activitiesQuery = query(
    collection(db, 'activities'),
    where('userId', '==', user.uid),
    limit(20)
  );
  const activitiesSnapshot = await getDocs(activitiesQuery);
  setActivities(activitiesSnapshot.docs.map(d => ({ id: d.id, ...d.data() })));
} catch (e) {
  console.warn('Could not load activities:', e.message);
}
    }
    setInitialLoading(false);
  } else {
    // User signed out
    setCurrentUser(null);
    setView('login');
    setClaimedBooks([]);
    setBookProgress([]);
    setNotifications([]); // 🔔 ADDED: Clear notifications on logout
        if (unsubscribeUser) unsubscribeUser();
        if (unsubscribeClaimed) unsubscribeClaimed();
        if (unsubscribeProgress) unsubscribeProgress();
        if (unsubscribeBooks) unsubscribeBooks();
        if (unsubscribeReviews) unsubscribeReviews();
        setInitialLoading(false);
      }
    });
  };

  

  initializeApp();

  // Cleanup function
  return () => {
    if (unsubscribeAuth) unsubscribeAuth();
    if (unsubscribeBooks) unsubscribeBooks();
    if (unsubscribeReviews) unsubscribeReviews();
    if (unsubscribeUser) unsubscribeUser();
    if (unsubscribeProgress) unsubscribeProgress();
    if (unsubscribeClaimed) unsubscribeClaimed();
  };
}, []);









useEffect(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const refCode = urlParams.get('ref');
  
  if (refCode) {
  console.log('Referral code detected:', refCode);
  trackAffiliateClick(refCode);  // ← ADD: tracks on Google + TikTok
  trackReferralClick(refCode);
    // ✅ Store in localStorage so we can use it after signup
    localStorage.setItem('vibelyReferralCode', refCode);
localStorage.setItem('vibelyReferralTimestamp', new Date().toISOString());
  }
}, []);

useEffect(() => {
  const now = new Date();
  
  
  // Check and update expired subscriptions
  setUsers(prev => prev.map(user => {
    let updated = { ...user };
    
    // Check review subscription expiry
    if (user.reviewSubscription?.active && 
        user.reviewSubscription?.expiresAt && 
        new Date(user.reviewSubscription.expiresAt) <= now) {
      updated.reviewSubscription = {
        ...user.reviewSubscription,
        active: false,
        plan: 'free'
      };
      
      // Notify if it's current user
      if (user.id === currentUser?.id) {
        alert('⚠️ Your Review Plan has expired!\n\nSubscribe again to continue submitting unlimited reviews.');
      }
    }
    
    return updated;
  }));
  
 
  // Check every minute for expired subscriptions
  const interval = setInterval(() => {
    const now = new Date();
    setUsers(prev => prev.map(user => {
      let updated = { ...user };
      
      if (user.reviewSubscription?.active &&
          user.reviewSubscription?.expiresAt &&
          new Date(user.reviewSubscription.expiresAt) <= now) {
        updated.reviewSubscription = { ...user.reviewSubscription, active: false, plan: 'free' };
      }

      return updated;
    }));
  }, 60000); // Check every 60 seconds
  
  return () => clearInterval(interval);
}, [currentUser?.id]);



// 3. UPDATE YOUR LOGOUT FUNCTION
// Replace your existing handleLogout function with this:

const handleLogout = async () => {
  await signOutUser();
  setCurrentUser(null);
  setNotifications([]); // 🔔 ADDED: Clear notifications on logout
  setView('login');
};

  // ===== helpers =====
const canClaimThisWeek = (user) => {
  const WEEKLY_LIMIT = 10;
  const FREE_USER_TOTAL_LIMIT = 10;
  

  if (!user) return { allowed: false, remaining: 0, message: 'Not signed in' };

  // Check if free user has reached lifetime limit
  if (!user.subscription?.active && !user.isAdmin) {
    const totalReviews = user.reviewsSubmitted || 0;
    if (totalReviews >= FREE_USER_TOTAL_LIMIT) {
      return {
        allowed: false,
        remaining: 0,
        message: `You've completed ${FREE_USER_TOTAL_LIMIT} free reviews. Subscribe to continue reviewing books!`
      };
    }
  }

  // Handle missing reset date safely
  if (!user.weeklyClaimsResetDate) {
    return { allowed: true, remaining: WEEKLY_LIMIT };
  }

  const now = new Date();
  const resetDate = new Date(user.weeklyClaimsResetDate);

  if (now - resetDate > 7 * 24 * 60 * 60 * 1000) {
    return { allowed: true, remaining: WEEKLY_LIMIT };
  }

  const remaining = WEEKLY_LIMIT - (user.weeklyClaimsUsed || 0);

  return {
    allowed: remaining > 0,
    remaining,
    message: remaining === 0
      ? `You've reached your weekly limit of ${WEEKLY_LIMIT} books.`
      : null
  };
};

const calculateDeadline = (pageCount) => {
  const daysToRead = pageCount < 200 ? 2 : pageCount < 350 ? 3 : 4;
  return new Date(Date.now() + daysToRead * 24 * 60 * 60 * 1000).toISOString();
};

 
/**
 * Check if book owner has enough coins to pay for reviews
 */
const canBookOwnerPayForReview = (book) => {
  if (!book) return false;
  
  const coinsRequired = book.coinsRequired || 10;
  
  // If it's the current user's book, check their coins directly
  if (book.uploadedBy === currentUser?.id) {
    return currentUser.coins >= coinsRequired;
  }
if (typeof book.ownerCoins === 'number') {
    return book.ownerCoins >= coinsRequired;
  }

  
  
  // ✅ PRIORITY 1: Check if owner coins are stored on the book itself
  if (book.ownerCoins !== undefined) {
    const coinsRequired = book.coinsRequired || 10;
    const hasEnough = book.ownerCoins >= coinsRequired;
    
    if (!hasEnough) {
      console.log(`📕 Hiding book "${book.title}" - owner has ${book.ownerCoins} coins, needs ${coinsRequired}`);
    }
    
    return hasEnough;
  }
  
  // ✅ PRIORITY 2: Check if this is the current user's book
  if (book.uploadedBy === currentUser?.id) {
    const coinsRequired = book.coinsRequired || 10;
    const hasEnough = currentUser.coins >= coinsRequired;
    
    if (!hasEnough) {
      console.log(`📕 Hiding YOUR book "${book.title}" - you have ${currentUser.coins} coins, need ${coinsRequired}`);
    }
    
    return hasEnough;
  }
  
  // ✅ PRIORITY 3: If we can't verify owner's coins, HIDE the book by default
  // This is safer - books only show if we can confirm owner has enough coins
  console.log(`📕 Hiding book "${book.title}" - owner coin balance unknown (uploadedBy: ${book.uploadedBy})`);
  return false;
};

// ✅ NEW: Actually reset weeklyClaimsUsed in Firebase when 7 days have passed
useEffect(() => {
  if (!currentUser?.id || currentUser?.isAdmin) return;

  const resetDate = currentUser.weeklyClaimsResetDate 
    ? new Date(currentUser.weeklyClaimsResetDate) 
    : null;
  const now = new Date();

  const needsReset = !resetDate || (now - resetDate > 7 * 24 * 60 * 60 * 1000);

  if (needsReset && currentUser.weeklyClaimsUsed > 0) {
    // Reset in Firebase so the stored value matches reality
    updateUser(currentUser.id, {
      weeklyClaimsUsed: 0,
      weeklyClaimsResetDate: new Date().toISOString()
    });

    // Update local state immediately too
    setCurrentUser(prev => ({
      ...prev,
      weeklyClaimsUsed: 0,
      weeklyClaimsResetDate: new Date().toISOString()
    }));

    console.log('✅ Weekly claims reset - 7 days passed');
  }
}, [currentUser?.id, currentUser?.weeklyClaimsResetDate]);

useEffect(() => {
  if (!currentUser?.id || currentUser?.isAdmin) return;
 
  // Check for expired claims when user logs in
  // This reverses coins for any missed deadlines
  const checkExpired = async () => {
  console.log('🔍 Checking for expired claims...');
  const result = await reverseExpiredClaimsServer();
  if (result.success && result.releasedCount > 0) {
      console.log(`✅ Reversed ${result.releasedCount} expired claims`);
      // Refresh books to show any that reappeared
      const booksResult = await getAllBooks();
      if (booksResult.success) {
        setBooks(booksResult.books);
      }
    }
  };
 
  checkExpired();
 
  // Also check every hour while user is active
  const interval = setInterval(checkExpired, 60 * 60 * 1000);
  return () => clearInterval(interval);
}, [currentUser?.id]);

// ===== Auto-expire promoted books =====

useEffect(() => {
  if (!currentUser?.id) return;

  // ✅ Update local state immediately
  setBooks(prev => prev.map(book => {
    if (book.uploadedBy === currentUser.id) {
      return { ...book, ownerCoins: currentUser.coins };
    }
    return book;
  }));

  // ✅ Also persist to Firebase so books reappear after refresh
  const syncCoinsToBooks = async () => {
    try {
      const { updateUserBookOwnerCoins } = await import('./firebaseService');
      await updateUserBookOwnerCoins(currentUser.id, currentUser.coins);
      console.log('✅ Synced ownerCoins to Firebase:', currentUser.coins);
    } catch (e) {
      console.warn('Could not sync ownerCoins to books:', e.message);
    }
  };

  syncCoinsToBooks();
}, [currentUser?.coins]);


useEffect(() => {
  const handlePopState = (e) => {
    e.preventDefault();
    if (currentUser && view !== 'home' && view !== 'login') {
      setView('home');
    }
    window.history.pushState(null, '', window.location.pathname);
  };

  window.history.pushState(null, '', window.location.pathname);
  window.addEventListener('popstate', handlePopState);

  return () => window.removeEventListener('popstate', handlePopState);
}, [view, currentUser]);


   //HANDLEAUTH
 // COMPLETE UPDATED handleAuth FUNCTION:
// ============================================

const handleAuth = async () => {
  setLoading(true);

  // ✅ DEMO ACCOUNT LOGIN
  if (authForm.email.toLowerCase() === 'demo@vibely.com' && authForm.password === 'demo123') {
    const result = await signInUser('demo@vibely.com', 'demo123');
    setLoading(false);
    
    if (result.success) {
      alert('🎮 Welcome to Demo Mode!\n\nYou have 10,000 coins to explore the app.');
      return;
    } else {
      alert('❌ Demo login failed: ' + result.error);
      return;
    }
  }



  // 🔧 ADMIN DEMO ACCOUNT LOGIN
  if (authForm.email.toLowerCase() === 'admin@vibely.com' && authForm.password === 'admin123') {
    const result = await signInUser('admin@vibely.com', 'admin123');
    setLoading(false);
    
    if (result.success) {
      alert('👑 Welcome Admin!\n\nYou have full admin access.');
      return;
    } else {
      alert('❌ Admin login failed: ' + result.error);
      return;
    }
  }

  // Regular signup/login
  if (authForm.isSignup) {
    // ✅ Terms/Privacy checkbox must be checked before we even attempt signup
    if (!authForm.agreedToTerms) {
      alert('Please agree to the Terms of Service and Privacy Policy to create an account.');
      setLoading(false);
      return;
    }

    // Sign up with Firebase
    const result = await signUpUser(authForm.email, authForm.password, authForm.name);
    setLoading(false);


   if (result.success) {

  trackSignUp('email');
  // ✅ Don't grant full app access yet, but stay signed in - Firebase
  // already auto-signed the new user in, and keeping that session alive is
  // what lets STEP 5's own-doc Firestore write (and the resend flow) work
  // under rules keyed off request.auth. Just show the verify-email screen;
  // full access (and the welcome/onboarding flow) happens on their first
  // successful login AFTER verifying.
  const signupEmail = authForm.email;
  setAuthForm({ email: '', password: '', name: '', isSignup: false, agreedToTerms: false });
  if (auth.currentUser) {
    setUnverifiedFirebaseUser(auth.currentUser);
  }
  setVerifyEmailAddress(signupEmail);
  setShowVerifyEmail(true);
} else {
  // ✅ Device-limit / fraud block (fingerprint risk score OR 3+ accounts
  // on this device) - show the block reason and offer the reset flow.
  if (result.blocked) {
    const goToReset = window.confirm(
      (result.error || 'Account creation blocked on this device.') +
      '\n\nClick OK to open the password reset screen, or Cancel to dismiss.'
    );
    if (goToReset) {
      setShowForgotPassword(true);
    }
    return;
  }

  let errorMessage = 'Sign up failed. Please try again.';

  if (result.error.includes('email-already-in-use')) {
    errorMessage = 'This email is already registered. Please login instead.';
  } else if (result.error.includes('invalid-email')) {
    errorMessage = 'Invalid email address. Please check and try again.';
  } else if (result.error.includes('weak-password')) {
    errorMessage = 'Password is too weak. Use at least 6 characters.';
  }

  alert(errorMessage);
}

 } else {
  // Sign in with Firebase
  const result = await signInUser(authForm.email, authForm.password);
  setLoading(false); 
  
  if (result.success) {
    // ✅ Email verification gate - re-check the REAL Auth flag (reload()
    // picks up a verification that happened in another tab) before
    // granting access. onAuthChange enforces this too (belt-and-suspenders
    // for persisted sessions), but this stops a fresh login from ever
    // reaching the app in the first place. Stay signed in either way - only
    // "Back to Login" on the verify screen signs the user out.
    const verifyCheck = await checkEmailVerified();
    if (!verifyCheck.success || !verifyCheck.verified) {
      if (auth.currentUser) {
        setUnverifiedFirebaseUser(auth.currentUser);
      }
      setVerifyEmailAddress(result.user?.email || authForm.email);
      setShowVerifyEmail(true);
      setAuthForm({ email: '', password: '', name: '', isSignup: false, agreedToTerms: false });
      return;
    }

    trackLogin('email');
    // ✅ Just clear the form - onAuthChange listener handles navigation automatically
    setAuthForm({ email: '', password: '', name: '', isSignup: false, agreedToTerms: false });

    // ✅ First login after verifying - run the welcome/onboarding flow that
    // used to fire immediately at signup (relocated here since signup no
    // longer logs the user into the app until they've verified).
    if (result.user && !result.user.onboarded) {
      setPendingUser(result.user);
      setShowWelcome(true);
    }
  } else {
  let errorMessage = 'Sign up failed. Please try again.';
  
  // ✅ Fraud detection block - show clear message
  if (result.blocked) {
    alert(
      ' Account Creation Blocked\n\n' +
      'An account already exists on this device.\n\n' +
      'Each device can only have ONE account on Vibely Books.\n\n' +
      'Please log in to your existing account.\n' +
      'If you believe this is an error, contact support@vibelybooks.live'
    );
    setLoading(false);
    return;
  }

  if (result.error?.includes('email-already-in-use')) {
    errorMessage = 'This email is already registered. Please login instead.';
  } else if (result.error?.includes('invalid-email')) {
    errorMessage = 'Invalid email address. Please check and try again.';
  } else if (result.error?.includes('weak-password')) {
    errorMessage = 'Password is too weak. Use at least 6 characters.';
  }
  
  alert(errorMessage);
}
  }
};

// ✅ Resend the verification link from the verify-email screen
const handleResendVerification = async () => {
  setResendLoading(true);
  const result = await resendVerificationEmail(unverifiedFirebaseUser);
  setResendLoading(false);

  if (result.success) {
    alert('✅ Verification email sent! Check your inbox.');
  } else {
    alert('❌ ' + (result.error || 'Could not resend verification email. Please try logging in again.'));
  }
};

const handleForgotPassword = async () => {
  if (!resetEmail) {
    alert('Please enter your email address');
    return;
  }

  setLoading(true);
  const result = await resetPassword(resetEmail);
  setLoading(false);

  if (result.success) {
    alert('✅ Password reset email sent!\n\nCheck your inbox and follow the instructions to reset your password.');
    setShowForgotPassword(false);
    setResetEmail('');
  } else {
    alert('❌ ' + result.error);
  }
};


// ✅ UPDATED HANDLERS
const handleWelcomeContinue = async () => {
  setShowWelcome(false);
  
  if (pendingUser) {
    await updateUser(pendingUser.id, {
      onboarded: true,
      onboardedAt: new Date().toISOString()
    });

    // ✅ Track referral signup if user came via referral link
   const refCode = localStorage.getItem('vibelyReferralCode');
if (refCode) {
  try {
    console.log('🔗 Tracking referral signup for code:', refCode);
    const refResult = await trackReferralSignup(
      pendingUser.id,
      pendingUser.email,
      pendingUser.name,
      refCode  // ← pass explicitly, don't rely on localStorage inside function
    );
    console.log('Referral result:', refResult);
    if (refResult.success) {
      await updateUser(pendingUser.id, {
        referredBy: refCode,
        referredAt: new Date().toISOString()
      });
      localStorage.removeItem('vibelyReferralCode');
      localStorage.removeItem('vibelyReferralTimestamp');
      console.log('✅ Referral signup tracked successfully');
    } else {
      console.warn('Referral tracking failed:', refResult.error);
    }
  } catch (e) {
    console.warn('Referral tracking exception:', e.message);
  }
}
  }
  
  alert(`🎉 Welcome to Vibely!\n\nYou've received 50 FREE coins!\n\nStart reviewing books or upload your own book now!`);
  setPendingUser(null);
};



const handleCoinsPurchased = async (newBalance) => {
    setCurrentUser(prev => ({ ...prev, coins: newBalance }));
    setBooks(prev => prev.map(b =>
      b.uploadedBy === currentUser.id ? { ...b, ownerCoins: newBalance } : b
    ));
  };

  // Low-coin notification: fires once when balance drops below threshold
  useEffect(() => {
    if (!currentUser?.id || currentUser?.isAdmin) return;
    const coins = currentUser.coins || 0;
    const alreadyNotified = currentUser.lowCoinNotified === true;
    const hasBooks = books.some(b => b.uploadedBy === currentUser.id && b.status === 'approved');

    if (coins < LOW_COIN_THRESHOLD && hasBooks && !alreadyNotified) {
      (async () => {
        try {
          await createNotification(
            currentUser.id,
            'low_coins',
            '⚠️ Your books were hidden',
            `Your coin balance (${coins}) is below ${LOW_COIN_THRESHOLD}. Your books are hidden from Browse until you top up. Buy coins or complete reviews to restore them.`,
            { coins }
          );
          await updateUser(currentUser.id, { lowCoinNotified: true });
          setCurrentUser(prev => ({ ...prev, lowCoinNotified: true }));
        } catch (e) {
          console.warn('Low coin notification failed:', e.message);
        }
      })();
    }

    if (coins >= LOW_COIN_THRESHOLD && alreadyNotified) {
      updateUser(currentUser.id, { lowCoinNotified: false });
      setCurrentUser(prev => ({ ...prev, lowCoinNotified: false }));
    }
  }, [currentUser?.coins]);


const handleClaimBook = async (bookId) => {
  const book = books.find(b => b.id === bookId);
  if (!book) return alert('Book not found');

  // ── STEP 1: ALL LOCAL VALIDATION FIRST (instant, no server) ──
  if (book.uploadedBy === currentUser.id)
    return alert('You cannot review your own book!');

  const activityCheck = canDoActivity(currentUser);
if (!activityCheck.allowed) {
  setShowSubscriptionModal(true);
  return alert(activityCheck.reason || 'Cannot claim at this time');
}

  const alreadyClaimed = claimedBooks.find(
    cb => cb.bookId === bookId && cb.userId === currentUser.id
  );
  if (alreadyClaimed) return alert('You have already claimed this book.');

  const hasReviewed = reviews.find(
    r => r.bookId === bookId && r.reviewerId === currentUser.id
  );
  if (hasReviewed) return alert('You already submitted a review for this book.');

  const ownerReviewedMyBooks = reviews.find(
    r => r.reviewerId === book.uploadedBy &&
    books.find(b => b.id === r.bookId && b.uploadedBy === currentUser.id)
  );
  if (ownerReviewedMyBooks)
    return alert('You cannot review books from authors who have reviewed your books.');

  const coinsRequired = book.coinsRequired || 10;

  // ── STEP 2: SHOW LOADING ──
  setLoading(true);

  // ── STEP 3: SERVER creates lock/claim/progress (claiming is free — the
  // author already paid for this copy at Request Review) ──
  const claimResult = await claimBookServer(bookId);

  if (!claimResult.success) {
    setLoading(false);
    return alert('Unable to claim book: ' + claimResult.error);
  }

  const deadline = claimResult.deadline;
  const turnaroundDays = book.turnaroundDays || 7;

  // ── STEP 4: UPDATE LOCAL STATE IMMEDIATELY ──
  const now = new Date();
  const resetDate = new Date(currentUser.weeklyClaimsResetDate);
  let updatedWeeklyCount = (currentUser.weeklyClaimsUsed || 0) + 1;
  let updatedResetDate = currentUser.weeklyClaimsResetDate;
  if (now - resetDate > 7 * 24 * 60 * 60 * 1000) {
    updatedWeeklyCount = 1;
    updatedResetDate = new Date().toISOString();
  }

  setClaimedBooks(prev => [...prev, {
    id: claimResult.claimId,
    bookId,
    userId: currentUser.id,
    claimedAt: new Date().toISOString(),
    deadline,
    turnaroundDays,
    lockId: claimResult.lockId
  }]);

  setBooks(prev => prev.map(b =>
    b.id === bookId ? {
      ...b,
      claimedCount: (b.claimedCount || 0) + 1,
      activeReaders: (b.activeReaders || 0) + 1
    } : b
  ));

  setCurrentUser(prev => ({
    ...prev,
    weeklyClaimsUsed: updatedWeeklyCount,
    weeklyClaimsResetDate: updatedResetDate
  }));

  // ── STEP 5: HIDE LOADING, SHOW SUCCESS ──
  setLoading(false);

  trackBookClaimed(book.title, coinsRequired);

  alert(
    ` Book claimed successfully!\n\n` +
    ` Review deadline: ${new Date(deadline).toLocaleDateString('en-US', {
      month: 'long', day: 'numeric', year: 'numeric'
    })}\n\n` +
    `You have ${turnaroundDays} days to read and review this book.\n\n` +
    `⚠️ If you don't submit before the deadline, you'll lose this claim and the book returns to others.`
  );

  // ── STEP 6: NON-CRITICAL BACKGROUND OPS (parallel) ──
  // Server already created the claim/lock/progress records (no coins move on claim).
  // Only the weekly-count update + notification remain client-side.
  Promise.all([
    updateUser(currentUser.id, {
      weeklyClaimsUsed: updatedWeeklyCount,
      weeklyClaimsResetDate: updatedResetDate
    }),

    NotificationTriggers.onBookClaimed(
      book.uploadedBy,
      book.title,
      currentUser.name,
      deadline
    ),

    updatedWeeklyCount >= 10
      ? NotificationTriggers.onWeeklyLimitReached(currentUser.id)
      : Promise.resolve()

  ]).catch(err => {
    console.warn('Background claim ops error (non-critical):', err.message);
  });
};
 // ===== UPDATED handleSubmitReview - NOW ACCEPTS BOTH reviewForm AND reviewData =====
const handleSubmitReview = async (reviewData) => { 
  setLoading(true);
  
  // Support both old reviewForm and new reviewData parameter
  const data = reviewData || reviewForm;
  
  const reviewCheck = canDoActivity(currentUser);
if (!reviewCheck.allowed) {
  setLoading(false);
  alert(reviewCheck.reason || 'Cannot submit review');
  setShowSubscriptionModal(true);
  return;
}

  if (!data.reviewText || !data.amazonReviewLink) {
    setLoading(false);
    alert('Please write a review and provide the Amazon review link');
    return;
  }

  const wordCount = data.reviewText.trim().split(/\s+/).filter(w => w).length;
  if (wordCount < 15) {
    setLoading(false);
    alert(`Your review must be at least 15 words. Current: ${wordCount}`);
    return;
  }

  if (!data.bookId) {
    setLoading(false);
    alert('No book selected');
    return;
  }

 
  const result = await submitReviewServer({
    bookId: data.bookId,
    reviewerName: data.reviewerName || currentUser.name,
    rating: data.rating || 5,
    reviewText: data.reviewText,
    amazonReviewLink: data.amazonReviewLink,
    marketplace: data.marketplace || currentUser?.country || 'US',
    proofScreenshot: data.proofScreenshot || 'Link provided',
    amazonReviewerName: data.amazonReviewerName || currentUser.name,
    wordCount
  });

  setLoading(false);


if (result.success) {

    // ✅ Remove book from claimed books (removes from "To Review" section)
    setClaimedBooks(prev => prev.filter(cb => !(cb.bookId === data.bookId && cb.userId === currentUser.id)));

    // ✅ Update local book progress state to review_submitted (server already persisted this)
    const progress = bookProgress.find(bp => bp.bookId === data.bookId && bp.reviewerId === currentUser.id);
    if (progress?.id) {
      setBookProgress(prev => prev.map(bp =>
        bp.id === progress.id
          ? { ...bp, stage: 'review_submitted', reviewSubmittedAt: new Date().toISOString() }
          : bp
      ));
    }

    // ✅ Update user's review count if not subscribed
    if (!currentUser.reviewSubscription?.active && !currentUser.isAdmin) {
      await updateUser(currentUser.id, {
        reviewsSubmitted: (currentUser.reviewsSubmitted || 0) + 1
      });
      setCurrentUser(prev => ({
        ...prev,
        reviewsSubmitted: (prev.reviewsSubmitted || 0) + 1
      }));
    }

    // Reset form only if using old reviewForm state
    if (!reviewData) {
      setReviewForm({ 
        bookId: null, 
        rating: 5, 
        reviewText: '', 
        amazonReviewLink: '', 
        proofScreenshot: '', 
        amazonReviewerName: '' 
      });
    }

    // 🔔 NOTIFICATION: Notify reviewer that review was submitted
    const book = books.find(b => b.id === data.bookId);
    trackReviewSubmitted(book?.title || 'Unknown', data.rating); 
    await NotificationTriggers.onReviewSubmitted(
      currentUser.id,
      book?.title || 'Unknown Book'
    );
    
    alert('✅ Review submitted successfully!\n\nYour review is now pending admin approval. You will receive your coins once approved.');
    
    // ✅ Redirect to My Reviews page
    setView('myReviews');
  } else {
    alert('Failed to submit review: ' + result.error);
  }
};





// ===== selectors =====
const getUserClaimedBooks = () => {
  if (!claimedBooks || !Array.isArray(claimedBooks)) return [];
  if (!books || !Array.isArray(books)) return [];
  if (!currentUser?.id) return [];
  
  return claimedBooks
    .filter(cb => cb.userId === currentUser.id)
    .map(cb => books.find(b => b.id === cb.bookId))
    .filter(book => book); // Remove undefined books
};









const getAnalytics = () => {
  if (!books || !reviews || !currentUser?.id) {
    return { totalReviews: 0, avgRating: 0, reviewVelocity: 0, totalBooks: 0 };
  }
  
  const userBooks = books.filter(b => b.uploadedBy === currentUser.id);
  const userReviews = reviews.filter(r => userBooks.some(b => b.id === r.bookId) && r.status === 'approved');
  const totalReviews = userReviews.length;
  const avgRating = totalReviews > 0 ? (userReviews.reduce((s, r) => s + r.rating, 0) / totalReviews).toFixed(1) : 0;
  const now = new Date();
  const lastWeekReviews = userReviews.filter(r => {
    const approvedAt = new Date(r.approvedAt || r.submittedAt || new Date());
    return (now - approvedAt) / (1000*60*60*24) <= 7;
  }).length;
  const reviewVelocity = (lastWeekReviews / 7).toFixed(1);
  return { totalReviews, avgRating, reviewVelocity, totalBooks: userBooks.length };
};

  // ===== small UI helpers =====
 
  

  if (initialLoading) {
  return <FullPageLoading />;
}

// ✅ ADD THESE BEFORE showWelcome
if (showTerms) {
  return (
    <TermsOfService 
      readOnly={true}
      onClose={() => setShowTerms(false)}
    />
  );
}

if (showPrivacy) {
  return (
    <PrivacyPolicy 
      readOnly={true}
      onClose={() => setShowPrivacy(false)}
    />
  );
}
// ===== VERIFY EMAIL SCREEN =====
if (showVerifyEmail) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-purple-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md text-center">
        <div className="flex items-center justify-center mb-6">
          <Book className="w-12 h-12 text-indigo-600 mr-3" />
          <h1 className="text-3xl font-bold text-gray-800">Vibely books</h1>
        </div>
        <h2 className="text-xl font-semibold text-gray-800 mb-3">Verify your email</h2>
        <p className="text-gray-600 mb-6">
          We've sent a verification link to <strong>{verifyEmailAddress}</strong>. Please check your inbox and click the link to verify your account, then log in.
        </p>

        <button
          onClick={handleResendVerification}
          disabled={resendLoading}
          className="w-full bg-indigo-600 text-white py-2.5 rounded-lg hover:bg-indigo-700 disabled:bg-indigo-400 disabled:cursor-not-allowed flex items-center justify-center gap-2 mb-3"
        >
          {resendLoading ? (
            <>
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
              <span>Sending...</span>
            </>
          ) : (
            <span>Resend verification email</span>
          )}
        </button>

        <button
          onClick={async () => {
            // ✅ The one explicit, user-initiated exit from the verify
            // screen - this is the only place that signs an unverified
            // user out. Everything else keeps their session alive.
            await signOutUser();
            setShowVerifyEmail(false);
            setUnverifiedFirebaseUser(null);
            setVerifyEmailAddress('');
          }}
          className="w-full text-indigo-600 text-sm hover:underline"
        >
          ← Back to Login
        </button>
      </div>
    </div>
  );
}

// ===== WELCOME PAGE =====
  if (showWelcome && pendingUser) {
    return <WelcomePage userName={pendingUser.name} onContinue={handleWelcomeContinue} />;
  }

 


        //login
if (view === 'login') {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-purple-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md">
        <div className="flex items-center justify-center mb-6">
          <Book className="w-12 h-12 text-indigo-600 mr-3" />
          <h1 className="text-3xl font-bold text-gray-800">Vibely books</h1>
        </div>
        <p className="text-center text-gray-600 mb-6">
          {showForgotPassword ? 'RESET PASSWORD' : 'WELCOME'}
        </p>

        {/* 🔧 FORGOT PASSWORD FORM */}
        {showForgotPassword ? (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <input 
                type="email" 
                value={resetEmail} 
                onChange={(e) => setResetEmail(e.target.value)} 
                placeholder="Enter your email"
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                disabled={loading}
                autoComplete="email"
              />
              <p className="text-xs text-gray-500 mt-2">
                We'll send you a link to reset your password
              </p>
            </div>

            <button 
              onClick={handleForgotPassword} 
              disabled={loading}
              className="w-full bg-indigo-600 text-white py-2.5 rounded-lg hover:bg-indigo-700 disabled:bg-indigo-400 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                  <span>Sending...</span>
                </>
              ) : (
                <span>Send Reset Link</span>
              )}
            </button>

            <button 
              onClick={() => {
                setShowForgotPassword(false);
                setResetEmail('');
              }}
              className="w-full text-indigo-600 text-sm hover:underline"
              disabled={loading}
            >
              ← Back to Login
            </button>
          </div>
        ) : (
          /* 🔧 REGULAR LOGIN/SIGNUP FORM */
          <div className="space-y-4">
            {authForm.isSignup && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Name</label>
                <input 
                  type="text" 
                  value={authForm.name} 
                  onChange={(e) => setAuthForm(prev => ({ ...prev, name: e.target.value }))} 
                  className="w-full px-4 py-2 border rounded-lg"
                  disabled={loading}
                  autoComplete="name"
                />
              </div>
            )}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
              <input 
                type="email" 
                value={authForm.email} 
                onChange={(e) => setAuthForm(prev => ({ ...prev, email: e.target.value }))} 
                className="w-full px-4 py-2 border rounded-lg"
                disabled={loading}
                autoComplete={authForm.isSignup ? "email" : "username"}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
              <input 
                type="password" 
                value={authForm.password} 
                onChange={(e) => setAuthForm(prev => ({ ...prev, password: e.target.value }))} 
                className="w-full px-4 py-2 border rounded-lg"
                disabled={loading}
                autoComplete={authForm.isSignup ? "new-password" : "current-password"}
              />
            </div>
   
            {authForm.isSignup && (
              <div className="space-y-2">
                <div className="flex items-start gap-2">
                  <input
                    type="checkbox"
                    id="terms"
                    checked={authForm.agreedToTerms}
                    onChange={(e) => setAuthForm(prev => ({ ...prev, agreedToTerms: e.target.checked }))}
                    className="w-4 h-4 mt-1 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                    disabled={loading}
                  />
                  <label htmlFor="terms" className="text-sm text-gray-700 select-none">
                    I agree to the Terms of Service and Privacy Policy
                  </label>
                </div>
                
                <div className="flex gap-4 pl-6 text-xs">
                  <button
                    type="button"
                    onClick={() => setShowTerms(true)}
                    className="text-indigo-600 hover:text-indigo-800 underline"
                  >
                    Read Terms of Service
                  </button>
                  <button
                    type="button"
                    onClick={() => setShowPrivacy(true)}
                    className="text-indigo-600 hover:text-indigo-800 underline"
                  >
                    Read Privacy Policy
                  </button>
                </div>
              </div>
            )}

            
            
            <button 
              onClick={handleAuth} 
              disabled={loading}
              className="w-full bg-indigo-600 text-white py-2.5 rounded-lg hover:bg-indigo-700 disabled:bg-indigo-400 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                  <span>{authForm.isSignup ? 'Signing Up...' : 'Logging In...'}</span>
                </>
              ) : (
                <span>{authForm.isSignup ? 'Sign Up' : 'Log In'}</span>
              )}
            </button>

            <div className="mt-4 text-center">
              <button 
                onClick={() => setAuthForm(prev => ({ ...prev, isSignup: !prev.isSignup }))} 
                className="text-indigo-600 text-sm"
                disabled={loading}
              >
                {authForm.isSignup ? 'Already have an account? Log in' : "Don't have an account? Sign up"}
              </button>
            </div>
            
            {/* 🔧 FORGOT PASSWORD LINK (only on login) */}
            {!authForm.isSignup && (
              <div className="mt-4 text-center">
                <button 
                  onClick={() => setShowForgotPassword(true)} 
                  className="text-indigo-600 text-sm hover:underline"
                  disabled={loading}
                >
                  Forgot Password?
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
  // ===== MAIN UI =====

 
  return (
  <div className="min-h-screen bg-gray-50">
    {/* header */}
    <header className="bg-white shadow-sm border-b sticky top-0 z-40">
  <div className="max-w-7xl mx-auto px-3 py-3 flex items-center justify-between gap-2">

        
        <div className="flex items-center gap-2 flex-shrink-0">
  <Book className="w-7 h-7 text-indigo-600" />
  <h1 className="text-lg sm:text-xl font-bold text-gray-800">Vibely</h1>
  {currentUser?.isAdmin && (
    <span className="px-2 py-0.5 bg-red-100 text-red-800 text-xs font-semibold rounded-full">
      ADMIN
    </span>
  )}
</div>




        <div className="flex items-center gap-1 sm:gap-2">
  {/* Coins - hide label on very small screens */}
  <div className="flex items-center bg-gradient-to-r from-yellow-100 to-amber-100 px-2 py-1.5 rounded-lg border border-yellow-200">
    <Coins className="w-4 h-4 text-amber-600" />
    <span className="font-semibold text-amber-900 text-xs ml-1 hidden xs:inline sm:inline">
      {currentUser?.coins || 0}
    </span>
    <span className="font-semibold text-amber-900 text-xs ml-1 sm:hidden">
      {currentUser?.coins || 0}
    </span>
  </div>

  {/* Subscribe - desktop only */}
  {!currentUser?.isAdmin && !currentUser?.reviewSubscription?.active && (
    <button 
      onClick={() => setShowSubscriptionModal(true)} 
      className="hidden md:inline-flex items-center bg-gradient-to-r from-purple-600 to-indigo-600 px-3 py-1.5 rounded-lg text-white text-sm"
    >
      <Crown className="w-4 h-4 mr-1" />
      <span>Subscribe</span>
    </button>
  )}

  {/* Notification Bell */}
  <div className="relative">
    <button
      onClick={() => setNotificationsOpen(!notificationsOpen)}
      className="relative p-1.5 rounded-full hover:bg-gray-100 transition"
    >
      <Bell className="w-5 h-5 text-gray-600" />
      {notifications.filter(n => !n.read).length > 0 && (
        <span className="absolute -top-0.5 -right-0.5 bg-red-600 text-white text-xs font-bold rounded-full w-4 h-4 flex items-center justify-center">
          {notifications.filter(n => !n.read).length > 9 ? '9+' : notifications.filter(n => !n.read).length}
        </span>
      )}
    </button>

    {/* Notification Dropdown - FIXED for mobile */}
    {notificationsOpen && (
      <div className="absolute right-0 mt-2 w-72 sm:w-80 bg-white rounded-xl shadow-2xl border border-gray-200 z-50">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="font-bold text-gray-800 text-sm">
            Notifications ({notifications.filter(n => !n.read).length})
          </h3>
          {notifications.length > 0 && (
            <button onClick={clearAllNotifications} className="text-xs text-red-600 hover:text-red-700 font-medium">
              Clear All
            </button>
          )}
        </div>
        <div className="max-h-80 overflow-y-auto">
          {notifications.length === 0 ? (
            <div className="p-8 text-center">
              <Bell className="w-10 h-10 text-gray-300 mx-auto mb-3" />
              <p className="text-gray-600 font-medium text-sm">No notifications</p>
              <p className="text-xs text-gray-500 mt-1">You're all caught up!</p>
            </div>
          ) : (
            notifications
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              .map((notification) => (
                <div
                  key={notification.id}
                  className={`p-3 border-b hover:bg-gray-50 transition cursor-pointer ${!notification.read ? 'bg-blue-50' : ''}`}
                  onClick={() => markNotificationAsRead(notification.id)}
                >
                  <div className="flex items-start gap-2">
                    <div className="flex-1 min-w-0">
                      <h4 className="font-semibold text-xs text-gray-800 line-clamp-1">
                        {notification.title}
                      </h4>
                      <p className="text-xs text-gray-600 mt-0.5 line-clamp-2">
                        {notification.message}
                      </p>
                      <p className="text-xs text-gray-400 mt-1">
                        {new Date(notification.createdAt).toLocaleDateString()}
                      </p>
                    </div>
                    {!notification.read && (
                      <div className="w-2 h-2 bg-blue-600 rounded-full flex-shrink-0 mt-1" />
                    )}
                  </div>
                </div>
              ))
          )}
        </div>
        {notifications.length > 0 && (
          <div className="p-3 border-t bg-gray-50 text-center">
            <button onClick={() => setNotificationsOpen(false)} className="text-xs text-indigo-600 hover:text-indigo-700 font-medium">
              Close
            </button>
          </div>
        )}
      </div>
    )}
  </div>

  {/* User name - hidden on small mobile */}
  <div className="hidden sm:flex items-center gap-1">
    <User className="w-4 h-4 text-gray-500" />
    <span className="text-gray-700 text-sm truncate max-w-[80px]">{currentUser?.name}</span>
  </div>

 

  {/* Logout */}
  <button
    onClick={handleLogout}
    className="p-1.5 rounded-full hover:bg-red-50 transition"
    title="Logout"
  >
    <LogOut className="w-5 h-5 text-red-500" />
  </button>
</div>





       
      </div>
    </header>

      {/* nav (mobile-first) */}
      <nav className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-14">
            <div className="hidden md:flex md:gap-6 items-center">
              {currentUser?.isAdmin ? (
  <>
    <button onClick={() => { setView('admin'); setMobileMenuOpen(false); }} className={`px-4 py-2 font-medium ${view === 'admin' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-600 hover:text-gray-900'}`}>
      <CheckCircle className="w-4 h-4 inline mr-2" />Pending ({reviews.filter(r => r.status === 'pending').length})
    </button>
    <button onClick={() => { setView('home'); setMobileMenuOpen(false); }} className={`px-4 py-2 font-medium ${view === 'home' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-600 hover:text-gray-900'}`}>
      <Library className="w-4 h-4 inline mr-2" />All Books
    </button>
    <button onClick={() => { setView('support'); setMobileMenuOpen(false); }} className={`px-4 py-2 font-medium ${view === 'support' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-600 hover:text-gray-900'}`}>
      🎧 Support
    </button>
  </>
              ) : (
                <>
    

                   
                  <button onClick={() => { setView('home'); setMobileMenuOpen(false); }} className={`px-4 py-2 font-medium ${view === 'home' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-600 hover:text-gray-900'}`}>
                    <Home className="w-4 h-4 inline mr-2" />Browse
                  </button>
                  <button onClick={() => { setView('myBooks'); setMobileMenuOpen(false); }} className={`px-4 py-2 font-medium ${view === 'myBooks' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-600 hover:text-gray-900'}`}>
                    <Library className="w-4 h-4 inline mr-2" />My Books
                  </button>
                   <button onClick={() => setView('upload')} className="flex items-center bg-indigo-600 text-white px-3 py-1.5 rounded-lg text-sm">
                    <Upload className="w-4 h-4 mr-2" /> Upload
                  </button>
                  <button onClick={() => { setView('claimed'); setMobileMenuOpen(false); }} className={`px-4 py-2 font-medium ${view === 'claimed' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-600 hover:text-gray-900'}`}>
                    <Star className="w-4 h-4 inline mr-2" />To Review ({getUserClaimedBooks().length})
                  </button>
                  <button 
  onClick={() => { setView('myReviews'); setMobileMenuOpen(false); }} 
  className={`w-full text-left px-4 py-2 ${view === 'myReviews' ? 'text-indigo-600' : 'text-gray-700 hover:text-gray-900'}`}
>
  My Reviews ({reviews.filter(r => r.reviewerId === currentUser?.id).length})
</button>
                  <button onClick={() => { setView('analytics'); setMobileMenuOpen(false); }} className={`px-4 py-2 font-medium ${view === 'analytics' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-600 hover:text-gray-900'}`}>
                    <Award className="w-4 h-4 inline mr-2" />Analytics
                  </button>




<button
  onClick={() => setShowBuyCoins(true)}
  className="flex items-center gap-1.5 bg-yellow-500 text-white px-3 py-2 rounded-lg text-sm font-medium hover:bg-yellow-600"
>
  <Coins className="w-4 h-4" /> Buy Coins
</button>




{showBuyCoins && (
  <BuyCoinsModal
    user={currentUser}
    onClose={() => setShowBuyCoins(false)}
    onCoinsPurchased={handleCoinsPurchased}
  />
)}


<button onClick={() => { setView('settings'); setMobileMenuOpen(false); }}
  className={`px-4 py-2 font-medium ${view === 'settings' ? 'text-indigo-600 border-b-2 border-indigo-600' : 'text-gray-600'}`}>
   Settings
</button>
       
<button 
  onClick={() => { setView('support'); setMobileMenuOpen(false); }} 
  className={`w-full text-left px-4 py-2 ${view === 'support' ? 'text-indigo-600' : 'text-gray-700 hover:text-gray-900'}`}
>
  Support
</button>


                </>
              )}
            </div>

            {/* right: upload button on desktop + mobile toggle */}
            <div className="flex items-center gap-3">
              {(view === 'upload' || view === 'myBooks') && !currentUser?.isAdmin && (
                <div className="hidden md:block">
                  <button onClick={() => setView('upload')} className="flex items-center bg-indigo-600 text-white px-3 py-1.5 rounded-lg text-sm">
                    <Upload className="w-4 h-4 mr-2" /> Upload
                  </button>
                </div>
              )}
               

              <button className="md:hidden p-2 rounded-md text-gray-600 hover:bg-gray-100" onClick={() => setMobileMenuOpen(prev => !prev)}>
                {mobileMenuOpen ? (
                  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                ) : (
                  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" /></svg>
                )}
              </button>
            </div>
          </div>

          <div className={`${mobileMenuOpen ? 'block' : 'hidden'} md:hidden`}>
            <div className="pt-2 pb-4 space-y-1">
              {currentUser?.isAdmin ? (
  <>
    <button onClick={() => { setView('admin'); setMobileMenuOpen(false); }} className={`w-full text-left px-4 py-2 ${view === 'admin' ? 'text-indigo-600' : 'text-gray-700 hover:text-gray-900'}`}>
      Pending Reviews
    </button>
    <button onClick={() => { setView('home'); setMobileMenuOpen(false); }} className={`w-full text-left px-4 py-2 ${view === 'home' ? 'text-indigo-600' : 'text-gray-700 hover:text-gray-900'}`}>
      All Books
    </button>
    <button onClick={() => { setView('support'); setMobileMenuOpen(false); }} className={`w-full text-left px-4 py-2 ${view === 'support' ? 'text-indigo-600' : 'text-gray-700 hover:text-gray-900'}`}>
      🎧 Customer Support
    </button>
  </>
              ) : (
                
                <>
                
      
                  <button onClick={() => { setView('home'); setMobileMenuOpen(false); }} className={`w-full text-left px-4 py-2 ${view === 'home' ? 'text-indigo-600' : 'text-gray-700 hover:text-gray-900'}`}>Browse</button>
                  <button onClick={() => { setView('myBooks'); setMobileMenuOpen(false); }} className={`w-full text-left px-4 py-2 ${view === 'myBooks' ? 'text-indigo-600' : 'text-gray-700 hover:text-gray-900'}`}>My Books</button>
                  <button onClick={() => { setView('upload'); setMobileMenuOpen(false); }} className={`w-full text-left px-4 py-2 ${view === 'upload' ? 'text-indigo-600' : 'text-gray-700 hover:text-gray-900'}`}>Upload</button>
                  <button onClick={() => { setView('claimed'); setMobileMenuOpen(false); }} className={`w-full text-left px-4 py-2 ${view === 'claimed' ? 'text-indigo-600' : 'text-gray-700 hover:text-gray-900'}`}>To Review ({getUserClaimedBooks().length})</button>
                  <button onClick={() => { setView('myReviews'); setMobileMenuOpen(false); }} className={`w-full text-left px-4 py-2 ${view === 'myReviews' ? 'text-indigo-600' : 'text-gray-700 hover:text-gray-900'}`}>My Reviews ({reviews.filter(r => r.reviewerId === currentUser?.id).length})</button>
                  <button onClick={() => { setView('analytics'); setMobileMenuOpen(false); }} className={`w-full text-left px-4 py-2 ${view === 'analytics' ? 'text-indigo-600' : 'text-gray-700 hover:text-gray-900'}`}>Analytics</button>



                  <button
  onClick={() => setShowBuyCoins(true)}
  className="flex items-center gap-1.5 bg-yellow-500 text-white px-3 py-2 rounded-lg text-sm font-medium hover:bg-yellow-600"
>
  <Coins className="w-4 h-4" /> Buy Coins
</button>




{showBuyCoins && (
  <BuyCoinsModal
    user={currentUser}
    onClose={() => setShowBuyCoins(false)}
    onCoinsPurchased={handleCoinsPurchased}
  />
)}

<button
  onClick={() => { setView('settings'); setMobileMenuOpen(false); }}
  className={`w-full text-left px-4 py-2 ${view === 'settings' ? 'text-indigo-600' : 'text-gray-700 hover:text-gray-900'}`}
>
   Settings
</button>


 <button 
  onClick={() => { setView('support'); setMobileMenuOpen(false); }} 
  className={`w-full text-left px-4 py-2 ${view === 'support' ? 'text-indigo-600' : 'text-gray-600 hover:text-gray-900'}`}
>
  Customer Support
</button>
                </>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* main */}
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <div className="flex gap-6">
          <div className="flex-1">
            {/* trial card */}
            
            {!currentUser?.isAdmin && !currentUser?.reviewSubscription?.active && view === 'home' && (
  <div className="mb-6 bg-gradient-to-r from-purple-50 to-indigo-50 border-2 border-purple-200 rounded-xl p-4">
    <div className="flex items-center justify-between">
      <div>
          <p className="font-semibold text-gray-800"> Free Trial Active</p>
          <p className="text-sm text-gray-600">
  Free activities remaining: <strong>{Math.max(0, 3 - (currentUser?.activitiesUsed || 0))}</strong> of 3
  </p>
  {(currentUser?.activitiesUsed || 0) >= 3 && (
            <p className="text-sm text-red-600 font-semibold mt-1">
              ⚠️ Free trial exhausted. Subscribe to Review Plan to continue!
          </p>
          
        )}
   
      </div>
      <button onClick={() => setShowSubscriptionModal(true)} className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-4 py-2 rounded-lg text-sm">
        {(currentUser?.activitiesUsed || 0) >= 3 ? 'Subscribe Now' : 'View Plans'}
      </button>
    </div>
  </div>
)}

{/* Customer Support for regular users */}
{view === 'support' && !currentUser?.isAdmin && (
  <CustomerSupport 
    currentUser={currentUser} 
    onBack={() => setView('home')} 
  />
)}

{/* Admin Support for admins */}
{view === 'support' && currentUser?.isAdmin && (
  <AdminSupport 
    onBack={() => setView('admin')} 
  />
)}
            {/* weekly limit */}
            {!currentUser?.isAdmin && view === 'analytics' && (
  <div className="mb-6 bg-blue-50 border border-blue-200 rounded-xl p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-semibold text-gray-800"> Weekly Claim Limit</p>
                    <p className="text-sm text-gray-600">{canClaimThisWeek(currentUser).remaining} claims remaining this week</p>
                  </div>
                  <div className="text-right">
                    <p className="text-2xl font-bold text-blue-600">{currentUser?.weeklyClaimsUsed || 0}/10</p>
                    <p className="text-xs text-gray-500">Used</p>
                  </div>
                </div>
              </div>
            )}

            {/* admin */}
           
{/* ✅ ADD THIS - NEW ADMIN PANEL */}
{view === 'admin' && currentUser?.isAdmin && (
  <AdminPanel
    currentUser={currentUser}
    books={books}
    reviews={reviews}
    users={users}
    updateBook={updateBook}
    updateUser={updateUser}
    updateReviewStatus={updateReviewStatus}
    createActivity={createActivity}
    getCurrentUser={getCurrentUser}
    createNotification={createNotification}
    setBooks={setBooks}
    setReviews={setReviews}
    getAllBooks={getAllBooks}
  />
)}
            {/* Admin Book Management */}


            {/* writeReview (only when view === 'writeReview') */}
            {view === 'writeReview' && !currentUser?.isAdmin && (
              <div className="max-w-2xl mx-auto">
                <button onClick={() => setView('claimed')} className="text-indigo-600 mb-4">← Back to claimed books</button>
                <h2 className="text-2xl font-bold mb-4">Submit Your Review Proof</h2>
                <div className="bg-white rounded-xl shadow-md p-4">
                  {(() => {
                    const book = books.find(b => b.id === reviewForm.bookId);
                    return (
                      <>
                        <div className="mb-4">
                          <h3 className="text-lg font-bold">{book?.title}</h3>
                          <p className="text-sm text-gray-600">by {book?.author}</p>
                          <a href={book?.amazonLink} target="_blank" rel="noreferrer" className="text-sm text-blue-600 inline-flex items-center mt-1"><ExternalLink className="w-4 h-4 mr-1" />View on Amazon</a>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Rating</label>
                            <div className="flex gap-2">
                              {[1,2,3,4,5].map(star => (
                                <button key={star} onClick={() => setReviewForm(prev => ({ ...prev, rating: star }))} className="focus:outline-none">
                                  <Star className={`w-7 h-7 ${star <= reviewForm.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} />
                                </button>
                              ))}
                            </div>
                          </div>

                          <div>
                            <label className="block text-sm font-medium mb-1">Your Review Text</label>
                            <textarea value={reviewForm.reviewText} onChange={(e) => setReviewForm(prev => ({ ...prev, reviewText: e.target.value }))} rows="6" className="w-full px-3 py-2 border rounded-lg" placeholder="Write same review you posted on Amazon..." />
                            <p className="text-xs text-gray-500 mt-1">Word count: {reviewForm.reviewText.trim().split(/\s+/).filter(w => w).length} {reviewForm.reviewText.trim().split(/\s+/).filter(w => w).length < 15 ? '(min 15)' : '✓'}</p>
                          </div>

                          <div>
                            <label className="block text-sm font-medium mb-1">Amazon Reviewer Name</label>
                            <input type="text" value={reviewForm.amazonReviewerName} onChange={(e) => setReviewForm(prev => ({ ...prev, amazonReviewerName: e.target.value }))} className="w-full px-3 py-2 border rounded-lg" placeholder="Name shown on Amazon" />
                          </div>

                          <div>
                            <label className="block text-sm font-medium mb-1">Amazon Marketplace Review LINK</label>
                            <input type="url" value={reviewForm.amazonReviewLink} onChange={(e) => setReviewForm(prev => ({ ...prev, amazonReviewLink: e.target.value }))} className="w-full px-3 py-2 border rounded-lg" placeholder="https://amazon.com/review/..." />
                          </div>

                          <div>
                            <label className="block text-sm font-medium mb-1">Additional Proof </label>
                            <input type="text" value={reviewForm.proofScreenshot} onChange={(e) => setReviewForm(prev => ({ ...prev, proofScreenshot: e.target.value }))} className="w-full px-3 py-2 border rounded-lg" placeholder="Screenshot link or note" />
                          </div>

                          <div className="bg-green-50 p-3 rounded text-sm">
                            <strong>You'll earn {COIN_RATES.EARN_PER_REVIEW} coins</strong> after admin approves. Quality bonus possible.
                          </div>

                          <button onClick={handleSubmitReview} className="w-full bg-indigo-600 text-white py-2.5 rounded-lg">Submit Review for Approval</button>
                        </div>

     
  
                      </>
                    );
                  })()}
                </div>
              </div>
            )}

            {/* analytics */}
            {view === 'analytics' && (
              <div>
                <h2 className="text-2xl font-bold mb-4">Analytics Dashboard</h2>
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
                  {(() => {
                    const an = getAnalytics();
                    return (
                      <>
                        <div className="bg-white rounded-xl p-4 shadow"><p className="text-sm text-gray-600">Total Books</p><p className="text-2xl font-bold">{an.totalBooks}</p></div>
                        <div className="bg-white rounded-xl p-4 shadow"><p className="text-sm text-gray-600">Total Reviews</p><p className="text-2xl font-bold">{an.totalReviews}</p></div>
                        <div className="bg-white rounded-xl p-4 shadow"><p className="text-sm text-gray-600">Avg Rating</p><p className="text-2xl font-bold">{an.avgRating}/5</p></div>
                        <div className="bg-white rounded-xl p-4 shadow"><p className="text-sm text-gray-600">Reviews/Day (avg)</p><p className="text-2xl font-bold">{an.reviewVelocity}</p></div>
                      </>
                    );
                  })()}
                </div>
              </div>
            )}

            {/* myBooks */}
           

           {/* Browse Books (only show books where owner can pay) */}



    
{/* ✅ ADD THIS - NEW BROWSE BOOKS COMPONENT */}
{view === 'home' && !currentUser?.isAdmin && (
  <BrowseBooks
  key={currentUser?.id}
  currentUser={currentUser}
  books={books}
  claimedBooks={claimedBooks}
  reviews={reviews}
  handleClaimBook={handleClaimBook}
  setCurrentUser={setCurrentUser}
  setUsers={setUsers}
  loading={loading}

  />
)}

            {/* My Reviews view (only when view === 'myReviews') */}
           {/* ✅ ADD THIS - NEW MY REVIEWS COMPONENT */}
{view === 'myReviews' && !currentUser?.isAdmin && (
  <MyReviews
    currentUser={currentUser}
    books={books}
    reviews={reviews}
  />
)}

            {/* claimed / to-review */}
{view === 'claimed' && !currentUser?.isAdmin && (
  <ClaimedBooksWorkflow
    claimedBooks={claimedBooks}
    currentUser={currentUser}
    books={books}
    bookProgress={bookProgress}
    setView={setView}
    setReviewForm={setReviewForm}
    updateBookProgress={updateBookProgress}
    setBookProgress={setBookProgress}
    adaptAmazonLink={adaptAmazonLink}
    getMarketplaceInfo={getMarketplaceInfo}
    handleSubmitReview={handleSubmitReview}
    AMAZON_MARKETPLACES={AMAZON_MARKETPLACES}
  />
)}

{/* Upload Book Form */}
{view === 'upload' && !currentUser?.isAdmin && (
  <UploadBookForm
    currentUser={currentUser}
    books={books}
    onUploadSuccess={() => {
      setView('myBooks'); // Redirect to My Books after successful upload
    }}
  />
)}



           {/* My Uploaded Books (only here) */}
{/* ✅ ADD THIS - NEW MY BOOKS COMPONENT */}
{view === 'myBooks' && !currentUser?.isAdmin && (
  <MyBooks
    currentUser={currentUser}
    setCurrentUser={setCurrentUser}
    books={books}
    reviews={reviews}
    bookProgress={bookProgress}
    users={users}
    setView={setView}
  />
)}
{/* Affiliate Dashboard */}
{view === 'affiliate' && !currentUser?.isAdmin && currentUser?.isAffiliate && (
  <AffiliateDashboard currentUser={currentUser} />
)}

{/* Become Affiliate (if not yet affiliate) */}
{view === 'affiliate' && !currentUser?.isAdmin && !currentUser?.isAffiliate && (
  <div className="max-w-2xl mx-auto text-center p-12 bg-white rounded-xl shadow">
    <h2 className="text-3xl font-bold text-gray-800 mb-4">💰 Join Affiliate Program</h2>
    <p className="text-gray-600 mb-6">
      Earn commissions by referring authors and reviewers to Vibely Books!
    </p>
    <div className="grid grid-cols-2 gap-4 mb-8 text-left">
      <div className="bg-green-50 p-4 rounded-lg">
        <p className="font-bold text-green-800">Review Plan Monthly</p>
        <p className="text-green-600 text-2xl font-bold">$5</p>
        <p className="text-green-700 text-sm">per referral</p>
      </div>

      
      <div className="bg-purple-50 p-4 rounded-lg">
        <p className="font-bold text-purple-800">Review Plan Yearly</p>
        <p className="text-purple-600 text-2xl font-bold">$30</p>
        <p className="text-purple-700 text-sm">per referral</p>
      </div>
      <div className="bg-blue-50 p-4 rounded-lg">
        <p className="font-bold text-blue-800">Promo Plan Monthly</p>
        <p className="text-blue-600 text-2xl font-bold">$3</p>
        <p className="text-blue-700 text-sm">per referral</p>
      </div>
      <div className="bg-indigo-50 p-4 rounded-lg">
        <p className="font-bold text-indigo-800">Lifetime Recurring</p>
        <p className="text-indigo-600 text-2xl font-bold">10%</p>
        <p className="text-indigo-700 text-sm">of all purchases</p>
      </div>
    </div>
    <button
      onClick={async () => {
        const result = await createAffiliateAccount(
          currentUser.id,
          currentUser.name,
          currentUser.email
        );
        if (result.success) {
          alert('🎉 Welcome to the Affiliate Program!\n\nYour unique referral link is ready!');
          setCurrentUser(prev => ({
            ...prev,
            isAffiliate: true,
            referralCode: result.affiliateData.referralCode
          }));
        } else {
          alert('Failed: ' + result.error);
        }
      }}
      className="bg-purple-600 text-white px-8 py-4 rounded-xl text-lg font-bold hover:bg-purple-700 transition"
    >
      💰 Become an Affiliate
    </button>
  </div>
)}


{/* Settings Page */}
{view === 'settings' && !currentUser?.isAdmin && (
  <SettingsPage
    currentUser={currentUser}
    setCurrentUser={setCurrentUser}
    updateUser={updateUser}
    signOutUser={signOutUser}
    setView={setView}
    setShowSubscriptionModal={setShowSubscriptionModal}
  />
)}
          </div>









          {/* right sidebar (hidden on small screens) */}
          {!currentUser?.isAdmin && (
            <aside className="hidden md:block w-80 flex-shrink-0">
              <div className="bg-white rounded-xl shadow p-4 sticky top-4">
                <h3 className="font-semibold mb-3">Your Activity</h3>
                {activities.filter(a => {
                  const book = books.find(b => b.id === a.bookId);
                  return book && book.uploadedBy === currentUser?.id;
                }).slice(0,6).map(act => (
                  <div key={act.id} className="mb-3 border-b pb-2">
                    <p className="text-sm text-gray-700">{act.message}</p>
                    <p className="text-xs text-gray-400">{new Date(act.timestamp).toLocaleString()}</p>
                  </div>
                )) || <p className="text-sm text-gray-500">No recent activity</p>}
              </div>
            </aside>
          )}
        </div>
      </main>

      

      {showSubscriptionModal && (
  <SubscriptionModal 
    user={currentUser} 
    onClose={() => setShowSubscriptionModal(false)} 
    onSubscribe={async (subscriptionUpdate) => {
      // Server already activated the subscription + un-gated books.
      // Refresh the current user from Firebase to get the real state.
      try {
        const refreshed = await getCurrentUser(currentUser.id);
        if (refreshed.success) {
          setCurrentUser(refreshed.user);
        }
        // Refresh books so any un-gated books reappear
        const booksResult = await getAllBooks();
        if (booksResult.success) {
          setBooks(booksResult.books);
        }
      } catch (e) {
        console.warn('Could not refresh after subscription:', e.message);
      }
      setShowSubscriptionModal(false);
    }}
  />
)}
    {/* ✅ Blocking overlay during claim processing */}
      <ClaimLoadingOverlay show={loading} />
    </div>
  );
};

export default ReviewsApp;